import { Badge } from '@mantine/core';
import React from 'react';

import { Label } from 'types';

type LabelBadgeProps = {
  label: Label | string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onRemove?: () => void;
  style?: React.CSSProperties;
};

export function LabelBadge({ label, size = 'sm', onRemove, style }: LabelBadgeProps) {
  const isStringLabel = typeof label === 'string';
  const labelName = isStringLabel ? label : label.name;
  const labelColor = isStringLabel ? '#0052CC' : label.color || '#0052CC';

  return (
    <Badge
      size={size}
      style={{
        backgroundColor: labelColor,
        color: '#fff',
        cursor: onRemove ? 'pointer' : 'default',
        ...style,
      }}
      onClick={onRemove}
      onMouseDown={(e) => {
        if (onRemove) {
          e.preventDefault();
          onRemove();
        }
      }}
    >
      {labelName}
    </Badge>
  );
}
